import { registerLocaleData } from '@angular/common';
// import { ProfileComponent } from './Dashboard/profile/profile.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeEn from '@angular/common/locales/en';
import localeFrCh from '@angular/common/locales/fr-CH';
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  LOCALE_ID,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as Sentry from '@sentry/angular-ivy';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ToastrModule } from 'ngx-toastr';

import { GlobalErrorHandler } from './_handlers/global-error.handler';
import { HttpCancelInterceptor } from './_interceptors/http-cancel.interceptor';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SidebarComponent } from './Dashboard/Common/sidebar/sidebar.component';
import { Globals } from './globals';
import { FooterComponent as HomeFooterComponent } from './Home/Common/footer/footer.component';
import { DashboardLayoutComponent } from './Layouts/dashboard-layout/dashboard-layout.component';
import { HomeLayoutComponent } from './Layouts/home-layout/home-layout.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { SharedModule } from './shared/shared.module';

registerLocaleData(localeFrCh, 'fr-CH');
registerLocaleData(localeEn, 'en');

@NgModule({
  declarations: [
    AppComponent,
    DashboardLayoutComponent,
    HomeFooterComponent,
    HomeLayoutComponent,
    PagenotfoundComponent,
    SidebarComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    NgbModule,
    NgScrollbarModule,
    SharedModule,
    ToastrModule.forRoot(),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [
    Globals,
    {
      // Single handler: chunk-load failures trigger a throttled reload,
      // everything else is delegated to Sentry (see GlobalErrorHandler).
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'fr-CH' },
    // Uncomment if we need to cancel all HTTP calls when changing navigation
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: HttpCancelInterceptor,
    //   multi: true
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
